import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { StatRowItem } from "../card-types";

@Component({
  selector: "stat-row-card",
  templateUrl: "./stat-row-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class StatRowCardComponent implements OnChanges {
  @Input() icon: string;
  @Input() title: string;
  @Input() description: string;
  @Input() hint: string;
  @Input() stats: StatRowItem[] = [];
  @Input() statColumns: number;
  @Input() bandedStats: boolean = false;
  @Input() showExport: boolean = true;
  @Input() showDashboardLink: boolean = false;
  @Input() isReport: boolean = false;
  @Input() comingSoon: boolean = false;
  @Output() exportClick = new EventEmitter<void>();
  @Output() dashboardClick = new EventEmitter<void>();
  statFlex: string = null;

  ngOnChanges() {
    this.statFlex = null;
    if (this.statColumns) {
      this.statFlex = `0 0 ${100 / this.statColumns}%`;
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
